import { render, staticRenderFns } from "./CustomFile.vue?vue&type=template&id=384c8cb8"
import script from "./CustomFile.vue?vue&type=script&lang=js"
export * from "./CustomFile.vue?vue&type=script&lang=js"
import style0 from "./CustomFile.vue?vue&type=style&index=0&id=384c8cb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports